export type NotificationType = "success" | "error" | "warning" | "info"

export const NOTIFICATION_TYPE_LISTS = ["SUCCESS", "ERROR", "WARNING", "INFO"] as const

export const NOTIFICATION_TYPE_COLOR: Record<NotificationType, string> = {
  success: "green",
  error: "red",
  warning: "yellow",
  info: "blue",
} as const
